/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import getCurrentUser from './get-current-user';

export default (state) => get(getCurrentUser(state), ['isMultiStore'], '');
